import React from "react";
import { Dropdown } from "react-bootstrap";
import "../../assets/css/scss/component/dropdown/_materialDropdown.scss";
import { IReduxStateData } from "../../interfaces/redux";
import { useSelector } from "react-redux";
import { BASEBALL_STATISTICS_MENU } from "../../constant/match";

export default function MaterialDropdown(props: any) {
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLang = globalState?.selectedLang || "";
  console.log("dropdown >", props);
  return (
    <div className="material-dropdown-select">
      <Dropdown>
        <Dropdown.Toggle id="dropdown-basic">
          {BASEBALL_STATISTICS_MENU[selectedLang]["dropdown_default"]}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {props?.dropdown?.batting ? (
            <Dropdown.Item
              eventKey="0"
              className="text-uppercase"
              active={props?.activated === 0}
              onClick={() => props.onChange(0)}
            >
              {BASEBALL_STATISTICS_MENU[selectedLang]["dropdown_batting"]}
            </Dropdown.Item>
          ) : null}
          {props?.dropdown?.fielding ? (
            <Dropdown.Item
              eventKey="2"
              className="text-uppercase"
              active={props?.activated === 2}
              onClick={() => props.onChange(2)}
            >
              {BASEBALL_STATISTICS_MENU[selectedLang]["dropdown_fielding"]}
            </Dropdown.Item>
          ) : null}
          {props?.dropdown?.pitcher ? (
            <Dropdown.Item
              eventKey="1"
              className="text-uppercase"
              active={props?.activated === 1}
              onClick={() => props.onChange(1)}
            >
              {BASEBALL_STATISTICS_MENU[selectedLang]["dropdown_pitching"]}
            </Dropdown.Item>
          ) : null}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
